import { EventEmitter, Input, OnChanges, Output, SimpleChanges, Component, OnInit } from '@angular/core';
import { currencyParser, ngHelper, CustomComponent } from '@cakeiteasy/web-utils';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'yes-no-add-on-section',
  templateUrl: './yes-no-add-on-section.component.html',
  styleUrls: ['./yes-no-add-on-section.component.scss']
})
export class YesNoAddOnSectionComponent extends CustomComponent implements OnChanges, OnInit {

  @Input() group: any;
  @Input() products: any[];
  @Input() currency = 'kr';
  @Input() disabled: boolean;
  @Input() selectedProducts: any;
  @Output() onSelect = new EventEmitter<any>();

  public selectItems: any[];
  public selectedProductId: number;

  public yesNoForm = new FormGroup({
    yesNoResult: new FormControl<number>(0)
  });
  public yesOptionLabel: string;

  constructor(private _translate: TranslateService, private _fb: FormBuilder) {
    super();
  }

  ngOnInit() {
    this._subscribe();
  }

  public ngOnChanges(changes: SimpleChanges) {
    ngHelper.ifChanged(changes, 'products', (products) => {
      const p = products[1];
      const priceSuffix = p.price > 0 ? ` - ${currencyParser(p.price, this.currency)}` : '';
      this.yesOptionLabel = `${this._translate.instant('common.yes')}${priceSuffix}`;

      this.yesNoForm = this._fb.group({
        yesNoResult: [this.selectedProducts[0].id || 0]
      });
  });
}

  private _subscribe() {
    this.addSubscriber(this.yesNoForm.valueChanges.subscribe(form => {
      this.onSelect.emit([this.products[form.yesNoResult]]);
    }));
  }

}
